import React from "react";

import { graphql, useStaticQuery } from "gatsby";

interface KontentItemGlobalDataProps {
  data: [{
    codename: string;
    language: string;
    name: string;
    type: string;
  }];
}

interface Collection {
  allKontentItemGlobalData: {
    nodes: {
      system: {
        codename: string;
        id: string;
      };
      elements: {
        data: {
          value: string;
        };
      };
    }[];
  };
}

const KontentItemGlobalData: React.FC<KontentItemGlobalDataProps> = ({ data }) => {
  const globalData = data?.[0];

  const collection: Collection = useStaticQuery(graphql`
    {
      allKontentItemGlobalData {
        nodes {
          system {
            codename
            id
          }
          elements {
            data {
              value
            }
          }
        }
      }
    }
  `);

  if (collection.allKontentItemGlobalData) {
    const figures = collection.allKontentItemGlobalData.nodes;

    const item = figures.find((el) => el.system.codename === globalData.codename);

    if (item) {
      return item.elements.data.value;
    }
  }

  return null;
};

export default KontentItemGlobalData;
